module.exports = __webpack_public_path__ + "b925f75f38e20aab0e872ba84d1d0b27.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextCompPro-Bold.ttf
// module id = 44
// module chunks = 0